"use strict";
var unitas = unitas || {};
const foldOutTextInner = document.getElementById(
  "js-fold-out-text-inner"
);
const foldOutTextShowMore = document.getElementById(
  "js-fold-out-text-show-more"
);

unitas.foldOutText =
  unitas.foldOutText ||
  (function() {
    function init() {
      setupShowMoreText();
    }

    function setupShowMoreText() {
      if (foldOutTextInner && foldOutTextShowMore) {
        foldOutTextShowMore.addEventListener("click", function() {
          if (foldOutTextInner.style.maxHeight) {
            foldOutTextInner.classList.remove("open");
            foldOutTextShowMore.classList.remove("open");
            foldOutTextInner.style.maxHeight = null;
          } else {
            foldOutTextInner.classList.add("open");
            foldOutTextShowMore.classList.add("open");
            foldOutTextInner.style.maxHeight =
              foldOutTextInner.scrollHeight + "px";
          }
        });
      }
    }

    return {
      init: init,
    };
  })();
